import React from "react";
import { useEffect, useState } from 'react';

export function PatientDocumentItem({ card }: any): JSX.Element {
  const [imgURL, setImgURL] = useState('');

  useEffect(() => {
    if (card.file_content.data) {
      const binaryData = new Uint8Array(card.file_content.data);
      const blob = new Blob([binaryData], {
        type: card.file_content.mime_type,
      });
      const objectUrl = URL.createObjectURL(blob);

      setImgURL(objectUrl);
      return () => {
        URL.revokeObjectURL(objectUrl);
      };
    } else {
      setImgURL('');
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
  return (
    // all styles are written in PatientStyle.scss
    <div className='document-wrapper'>
      <div className='document-image-containers'>
        {/* for now we are using img tag as everything is image in future it may be changed if documents uploaded with other formate */}
        <img src={imgURL} alt={`${card.label} ${card.is_front ? ' Front' :'Back'}`} className='image' />
      </div>
      <div className='image-label'>
        { card.label } {card.is_front ? ' Front' :'Back'}
      </div>
    </div>
  );
}